export function hextoRgba(hex, opacity) {
  const hexValue = hex.replace('#', '');
  const r = parseInt(hexValue.substring(0, 2), 16);
  const g = parseInt(hexValue.substring(2, 4), 16);
  const b = parseInt(hexValue.substring(4, 6), 16);

  return `rgba(${r},${g},${b},${opacity})`;
}

export function getStatusColor(status, theme, type) {
  if (type === 'user') {
    return {
      Lead: theme.colors.black40w,
      Profiled: '#FF9000',
      Open: theme.colors.warning40w,
      Verified: theme.colors.primary60w,
      Active: theme.colors.success,
      Deleted: theme.colors.warning,
      undefined: theme.colors.warning,
    }[status];
  }

  if (type === 'account') {
    return {
      Draft: theme.colors.black40w,
      Opening: '#FF9000',
      Created: theme.colors.warning40w,
      Profiled: theme.colors.secondary40w,
      AcceptedProposal: theme.colors.secondary60w,
      WaitingContractSignature: theme.colors.warning60w,
      SignedContract: theme.colors.warning40w,
      Active: theme.colors.success,
      Financed: theme.colors.primary40w,
      Suspended: theme.colors.danger60w,
      undefined: theme.colors.warning,
    }[status];
  }

  if (type === 'portfolio') {
    return {
      Created: theme.colors.secondary,
      Financed: theme.colors.primary,
      OnTrack: theme.colors.success,
      OffTrack: theme.colors.danger,
    }[status];
  }

  if (type === 'lead') {
    return {
      New: theme.colors.chart2,
      InProgress: theme.colors.chart8,
      Connected: theme.colors.primary,
      Unqualified: theme.colors.warning,
    }[status];
  }

  return {
    // user
    Lead: theme.colors.secondary60w,
    Profiled: theme.colors.primary60w,
    Verified: theme.colors.primary60w,
    Active: theme.colors.primary20b,
    Deleted: theme.colors.warning,
    // account
    AcceptedProposal: theme.colors.primary60w,
    SignedContract: theme.colors.primary20b,
    // portfolio
    Created: theme.colors.secondary,
    Financed: theme.colors.primary,
    OnTrack: theme.colors.success,
    OffTrack: theme.colors.danger,
    // undefined
    undefined: theme.colors.warning,
  }[status];
}
